'use client';

import { convexClient } from '@convex-dev/better-auth/client/plugins';
import {
  emailOTPClient,
  inferAdditionalFields,
} from 'better-auth/client/plugins';
import { createAuthClient } from 'better-auth/react';

export const authClient = createAuthClient({
  plugins: [
    emailOTPClient(),
    convexClient(),
    inferAdditionalFields({
      user: {
        signupLocale: {
          type: 'string',
          required: false,
          input: true,
          returned: false,
        },
      },
    }),
  ],
});
